import React from 'react';
import { Camera, Lock, Mail, User, Globe } from 'lucide-react';
import { AppShell } from '../components/AppShell';
export function ProfilePage() {
  return <AppShell data-id="element-1007">
      <div className="p-6 lg:p-8 max-w-4xl mx-auto space-y-6" data-id="element-1008">
        <div data-id="element-1009">
          <h1 className="text-2xl text-navy-950 mb-1" data-id="element-1010">Mi Perfil</h1>
          <p className="text-sm text-navy-600" data-id="element-1011">
            Gestione su información personal y preferencias de cuenta.
          </p>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-1012">
          <div className="p-6 sm:p-8 flex flex-col md:flex-row gap-8" data-id="element-1013">
            {/* Avatar Section */}
            <div className="flex flex-col items-center space-y-4 shrink-0" data-id="element-1014">
              <div className="relative group cursor-pointer" data-id="element-1015">
                <div className="w-32 h-32 rounded-full bg-brand-50 border-4 border-white shadow-sm flex items-center justify-center text-4xl font-light text-brand-600 overflow-hidden" data-id="element-1016">
                  DR
                  <div className="absolute inset-0 bg-navy-950/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1017">
                    <Camera className="text-white" size={24} data-id="element-1018" />
                  </div>
                </div>
              </div>
              <div className="text-center" data-id="element-1019">
                <button className="text-sm font-medium text-brand-500 hover:text-brand-600 transition-colors" data-id="element-1020">
                  Cambiar avatar
                </button>
                <p className="text-xs text-slate-400 mt-1" data-id="element-1021">
                  JPG, GIF o PNG. Max 2MB.
                </p>
              </div>
            </div>

            {/* Form Section */}
            <div className="flex-1 space-y-6" data-id="element-1022">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-1023">
                <div className="space-y-1.5" data-id="element-1024">
                  <label className="block text-sm font-medium text-navy-950" data-id="element-1025">
                    Nombre
                  </label>
                  <div className="relative" data-id="element-1026">
                    <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-1027" />
                    <input type="text" defaultValue="Dr. Diego" className="w-full h-10 pl-10 pr-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" data-id="element-1028" />
                  </div>
                </div>
                <div className="space-y-1.5" data-id="element-1029">
                  <label className="block text-sm font-medium text-navy-950" data-id="element-1030">
                    Apellido
                  </label>
                  <input type="text" defaultValue="Rossi" className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" data-id="element-1031" />
                </div>
              </div>

              <div className="space-y-1.5" data-id="element-1032">
                <label className="block text-sm font-medium text-navy-950" data-id="element-1033">
                  Email corporativo
                </label>
                <div className="relative" data-id="element-1034">
                  <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-1035" />
                  <input type="email" defaultValue="drossi@pharmacorp.com" disabled className="w-full h-10 pl-10 pr-10 rounded-md border border-slate-200 bg-slate-50 text-slate-500 text-sm outline-none cursor-not-allowed" data-id="element-1036" />
                  <Lock size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-1037" />
                </div>
                <p className="text-xs text-slate-400" data-id="element-1038">
                  Contacte al administrador para cambiar su dirección de email.
                </p>
              </div>

              <div className="space-y-1.5" data-id="element-1039">
                <label className="block text-sm font-medium text-navy-950" data-id="element-1040">
                  Cargo / Rol
                </label>
                <input type="text" defaultValue="Director de Asuntos Regulatorios" className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" data-id="element-1041" />
              </div>

              <div className="space-y-1.5" data-id="element-1042">
                <label className="block text-sm font-medium text-navy-950" data-id="element-1043">
                  Zona horaria
                </label>
                <div className="relative" data-id="element-1044">
                  <Globe size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-1045" />
                  <select className="w-full h-10 pl-10 pr-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all appearance-none" data-id="element-1046">
                    <option value="ART" data-id="element-1047">Buenos Aires (GMT-3)</option>
                    <option value="CLT" data-id="element-1048">Santiago (GMT-3)</option>
                    <option value="PET" data-id="element-1049">Lima (GMT-5)</option>
                    <option value="COT" data-id="element-1050">Bogotá (GMT-5)</option>
                    <option value="CST" data-id="element-1051">CDMX (GMT-5)</option>
                  </select>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-1052">
                <button className="text-sm font-medium text-brand-500 hover:text-brand-600 transition-colors" data-id="element-1053">
                  Cambiar contraseña
                </button>
                <button className="bg-brand-500 hover:bg-brand-400 text-white text-sm font-medium px-6 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-1054">
                  Guardar cambios
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Digest Settings Section */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-1055">
          <div className="p-6 sm:p-8 space-y-6" data-id="element-1056">
            <div data-id="element-1057">
              <h2 className="text-lg text-navy-950 mb-1" data-id="element-1058">
                Preferencias de Notificaciones
              </h2>
              <p className="text-sm text-navy-600" data-id="element-1059">
                Configure cómo y cuándo desea recibir resúmenes de sus alertas
                regulatorias.
              </p>
            </div>

            <div className="space-y-5" data-id="element-1060">
              <div className="flex items-start justify-between gap-4 p-4 rounded-lg border border-slate-200 bg-slate-50/50" data-id="element-1061">
                <div data-id="element-1062">
                  <h3 className="text-sm font-medium text-navy-950" data-id="element-1063">
                    Resumen Ejecutivo (Digest)
                  </h3>
                  <p className="text-xs text-navy-600 mt-1" data-id="element-1064">
                    Reciba un email con el resumen de las novedades más
                    relevantes generadas por IA.
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer shrink-0 mt-1" data-id="element-1065">
                  <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1066" />
                  <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-brand-500/50 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-brand-500" data-id="element-1067"></div>
                </label>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-1068">
                <div className="space-y-1.5" data-id="element-1069">
                  <label className="block text-sm font-medium text-navy-950" data-id="element-1070">
                    Frecuencia
                  </label>
                  <select className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" data-id="element-1071">
                    <option value="daily" data-id="element-1072">Diario</option>
                    <option value="weekly" data-id="element-1073">Semanal (Viernes)</option>
                    <option value="realtime" data-id="element-1074">
                      En tiempo real (No recomendado)
                    </option>
                  </select>
                </div>
                <div className="space-y-1.5" data-id="element-1075">
                  <label className="block text-sm font-medium text-navy-950" data-id="element-1076">
                    Horario de entrega
                  </label>
                  <select className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" data-id="element-1077">
                    <option value="08:00" data-id="element-1078">08:00 AM</option>
                    <option value="09:00" data-id="element-1079">09:00 AM</option>
                    <option value="12:00" data-id="element-1080">12:00 PM</option>
                    <option value="18:00" data-id="element-1081">06:00 PM</option>
                  </select>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-100 flex justify-end" data-id="element-1082">
                <button className="bg-brand-500 hover:bg-brand-400 text-white text-sm font-medium px-6 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-1083">
                  Guardar preferencias
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppShell>;
}